import LabelBadge from "../../../Components/Label/LabelBadge";
export default function LabelList({ labels = [] }) {
    return (
        < div className="workitem-label-container">
            {labels.map((l, i) => <LabelBadge key={i} label={l.Label} />)}
        </div>
    )
}